const BatchFileValidationWorker = () => {
    self.stopProcessing = false;

    self.processValidation = (request) => {
        const { fileContents } = request;

        const lines = fileContents.split(/\r?\n/).filter(line => line.trim() !== ''); // Split by new lines and filter out empty lines

        processLine(0, lines, { status: 'InProgress', messages: [], progress: 0 }, []);
    }

    self.processLine = (currentIndex, lines, job, sequenceCollector) => {
        if (self.stopProcessing) {
            return;
        }

        const lineGroup = lines.filter((_, i) => i >= currentIndex && i < currentIndex + 1000);
        for (let i = 0; i < lineGroup.length; i++) {
            self.validateLine(currentIndex + i, lineGroup[i], job, sequenceCollector);
        }

        if (lines.length - 1 >= currentIndex) {
            if ((currentIndex + lineGroup.length) % 100 === 0) {
                job.progress = ((currentIndex + lineGroup.length) / lines.length) * 100;
                postMessage({
                    type: 'VALIDATION_PROGRESS',
                    data: {
                        ...job
                    }
                })
            }

            setTimeout(() => self.processLine(currentIndex + lineGroup.length, lines, job, sequenceCollector), 0);
        } else {
            job.status = job.messages.length > 0 ? 'Failed' : 'Success';
            postMessage({
                type: 'VALIDATION_COMPLETE',
                data: {
                    ...job
                }
            });
        }
    }

    self.validateLine = (index, line, job, sequenceCollector) => {
        const lineNumber = index + 1;
        const columns = line.split('\t');
        if (columns.length < 172) {
            job.messages.push(`Line ${lineNumber}: ${columns.length} fields were found on this line. All lines must contain exactly 172 fields.`);
            return;
        }
        const parsedLine = {
            sequenceNumber: columns[0],
            claimId: columns[1],
            lineNum: columns[2],
            contractId: columns[3],
            memberId: columns[4],
            dob: columns[5],
            gender: columns[6],
            fromDate: columns[7],
            toDate: columns[8],
            admitDate: columns[9],
            dischDate: columns[10],
            drg: columns[11],
            drgVersion: columns[12],
            revcode: columns[13],
            revCodeDesc: columns[14],
            hcpcs: columns[15],
            modifier: columns[16],
            modifier2: columns[17],
            pos: columns[18],
            specialty: columns[19],
            providerId: columns[20],
            providerZip: columns[21],
            renderingProviderId: columns[22],
            renderingProviderZip: columns[23],
            medicareId: columns[24],
            billType: columns[25],
            admitSource: columns[26],
            billed: columns[27],
            allowed: columns[28],
            units: columns[29],
            dischargeStatus: columns[30],
            icdDiag1: columns[31],
            icdDiag2: columns[32],
            icdDiag3: columns[33],
            icdDiag4: columns[34],
            icdDiag5: columns[35],
            icdDiag6: columns[36],
            icdDiag7: columns[37],
            icdDiag8: columns[38],
            icdDiag9: columns[39],
            icdDiag10: columns[40],
            icdDiag11: columns[41],
            icdDiag12: columns[42],
            icdDiag13: columns[43],
            icdDiag14: columns[44],
            icdDiag15: columns[45],
            icdDiag16: columns[46],
            icdDiag17: columns[47],
            icdDiag18: columns[48],
            icdDiag19: columns[49],
            icdDiag20: columns[50],
            icdDiag21: columns[51],
            icdDiag22: columns[52],
            icdDiag23: columns[53],
            icdDiag24: columns[54],
            icdDiag25: columns[55],
            icdDiag26: columns[56],
            icdDiag27: columns[57],
            icdDiag28: columns[58],
            icdDiag29: columns[59],
            icdDiag30: columns[60],
            poa1: columns[61],
            poa2: columns[62],
            poa3: columns[63],
            poa4: columns[64],
            poa5: columns[65],
            poa6: columns[66],
            poa7: columns[67],
            poa8: columns[68],
            poa9: columns[69],
            poa10: columns[70],
            poa11: columns[71],
            poa12: columns[72],
            poa13: columns[73],
            poa14: columns[74],
            poa15: columns[75],
            poa16: columns[76],
            poa17: columns[77],
            poa18: columns[78],
            poa19: columns[79],
            poa20: columns[80],
            poa21: columns[81],
            poa22: columns[82],
            poa23: columns[83],
            poa24: columns[84],
            poa25: columns[85],
            poa26: columns[86],
            poa27: columns[87],
            poa28: columns[88],
            poa29: columns[89],
            poa30: columns[90],
            icdProc1: columns[91],
            icdProc2: columns[92],
            icdProc3: columns[93],
            icdProc4: columns[94],
            icdProc5: columns[95],
            icdProc6: columns[96],
            icdProc7: columns[97],
            icdProc8: columns[98],
            icdProc9: columns[99],
            icdProc10: columns[100],
            icdProc11: columns[101],
            icdProc12: columns[102],
            icdProc13: columns[103],
            icdProc14: columns[104],
            icdProc15: columns[105],
            icdProc16: columns[106],
            icdProc17: columns[107],
            icdProc18: columns[108],
            icdProc19: columns[109],
            icdProc20: columns[110],
            icdProc21: columns[111],
            icdProc22: columns[112],
            icdProc23: columns[113],
            icdProc24: columns[114],
            icdProc25: columns[115],
            icdProc26: columns[116],
            icdProc27: columns[117],
            icdProc28: columns[118],
            icdProc29: columns[119],
            icdProc30: columns[120],
            conditionCode1: columns[121],
            conditionCode2: columns[122],
            conditionCode3: columns[123],
            conditionCode4: columns[124],
            conditionCode5: columns[125],
            conditionCode6: columns[126],
            conditionCode7: columns[127],
            conditionCode8: columns[128],
            conditionCode9: columns[129],
            conditionCode10: columns[130],
            conditionCode11: columns[131],
            occurrenceCode1: columns[132],
            occurrenceCode2: columns[133],
            occurrenceCode3: columns[134],
            occurrenceCode4: columns[135],
            occurrenceCodeDate1: columns[136],
            occurrenceCodeDate2: columns[137],
            occurrenceCodeDate3: columns[138],
            occurrenceCodeDate4: columns[139],
            valueCode1: columns[140],
            valueCode2: columns[141],
            valueCode3: columns[142],
            valueCode4: columns[143],
            valueCode5: columns[144],
            valueCode6: columns[145],
            valueCode7: columns[146],
            valueCode8: columns[147],
            valueCode9: columns[148],
            valueCode10: columns[149],
            valueCode11: columns[150],
            valueCode12: columns[151],
            valueCodeAmount1: columns[152],
            valueCodeAmount2: columns[153],
            valueCodeAmount3: columns[154],
            valueCodeAmount4: columns[155],
            valueCodeAmount5: columns[156],
            valueCodeAmount6: columns[157],
            valueCodeAmount7: columns[158],
            valueCodeAmount8: columns[159],
            valueCodeAmount9: columns[160],
            valueCodeAmount10: columns[161],
            valueCodeAmount11: columns[162],
            valueCodeAmount12: columns[163],
            siteNeutral: columns[164],
            dialysisOnsetDate: columns[165],
            pericarditis: columns[166],
            giTractBleeding: columns[167],
            hhsCAnemia: columns[168],
            myelodysplasticSyndrome: columns[169],
            currentAllowed: columns[170],
            zip: columns[171]
        };

        if (sequenceCollector.length !== 0 && !isNaN(parsedLine.sequenceNumber)) {
            const lastSequence = sequenceCollector[sequenceCollector.length - 1];
            if (!isNaN(lastSequence) && Number(parsedLine.sequenceNumber) <= Number(lastSequence)) {
                job.messages.push(`Line ${lineNumber}: Sequence Number (Column 1) must be in order from smallest to largest.`);
            }
        }

        if (sequenceCollector.includes(parsedLine.sequenceNumber)) {
            job.messages.push(`Line ${lineNumber}: Sequence Number (Column 1) must be unique.`);
        } else {
            sequenceCollector.push(parsedLine.sequenceNumber);
        }

        if (!parsedLine.sequenceNumber || isNaN(parsedLine.sequenceNumber)) {
            job.messages.push(`Line ${lineNumber}: Sequence Number (Column 1) must be an integer.`);
        }

        if (parsedLine.claimId && parsedLine.claimId.length > 60) {
            job.messages.push(`Line ${lineNumber}: Claim ID (Column 2) length must be less than or equal to 60.`);
        }

        if (parsedLine.lineNum && parsedLine.lineNum.length > 3) {
            job.messages.push(`Line ${lineNumber}: Line Number (Column 3) length must be less than or equal to 3.`);
        }

        if (parsedLine.contractId && parsedLine.contractId.length > 30) {
            job.messages.push(`Line ${lineNumber}: Contract ID (Column 4) length must be less than or equal to 30.`);
        }

        if (parsedLine.memberId && parsedLine.memberId.length > 40) {
            job.messages.push(`Line ${lineNumber}: Member ID (Column 5) length must be less than or equal to 40.`);
        }

        if (parsedLine.dob && !self.isValidDate(parsedLine.dob)) {
            job.messages.push(`Line ${lineNumber}: DOB (Column 6) must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.gender && parsedLine.gender.length > 1) {
            job.messages.push(`Line ${lineNumber}: Gender (Column 7) length must be less than or equal to 1.`);
        }

        if (parsedLine.fromDate && !self.isValidDate(parsedLine.fromDate)) {
            job.messages.push(`Line ${lineNumber}: From Date (Column 8) must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.toDate && !self.isValidDate(parsedLine.toDate)) {
            job.messages.push(`Line ${lineNumber}: To Date (Column 9) must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.admitDate && !self.isValidDate(parsedLine.admitDate)) {
            job.messages.push(`Line ${lineNumber}: Admit Date (Column 10) must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.dischDate && !self.isValidDate(parsedLine.dischDate)) {
            job.messages.push(`Line ${lineNumber}: Discharge Date (Column 11) must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.drg && parsedLine.drg.length !== 3) {
            job.messages.push(`Line ${lineNumber}: DRG (Column 12) length must be 3.`);
        }

        if (parsedLine.drgVersion && parsedLine.drgVersion.length > 5) {
            job.messages.push(`Line ${lineNumber}: DRG Version (Column 13) length must be less than or equal to 5.`);
        }

        if (parsedLine.revcode && parsedLine.revcode.length !== 4) {
            job.messages.push(`Line ${lineNumber}: Revcode (Column 14) length must be 4.`);
        }

        if (parsedLine.revCodeDesc && parsedLine.revCodeDesc.length > 24) {
            job.messages.push(`Line ${lineNumber}: RevCode Description (Column 15) length must be less than or equal to 24.`);
        }

        if (parsedLine.hcpcs && parsedLine.hcpcs.length !== 5) {
            job.messages.push(`Line ${lineNumber}: HCPCS (Column 16) length must be 5.`);
        }

        if (parsedLine.modifier && parsedLine.modifier.length > 2) {
            job.messages.push(`Line ${lineNumber}: Modifier (Column 17) length must be less than or equal to 2.`);
        }

        if (parsedLine.modifier2 && parsedLine.modifier2.length > 2) {
            job.messages.push(`Line ${lineNumber}: Modifier 2 (Column 18) length must be less than or equal to 2.`);
        }

        if (parsedLine.pos && parsedLine.pos.length > 2) {
            job.messages.push(`Line ${lineNumber}: POS (Column 19) length must be less than or equal to 2.`);
        }

        if (parsedLine.specialty && parsedLine.specialty.length > 2) {
            job.messages.push(`Line ${lineNumber}: Specialty (Column 20) length must be less than or equal to 2.`);
        }

        if (parsedLine.providerId && parsedLine.providerId.length > 40) {
            job.messages.push(`Line ${lineNumber}: Provider ID (Column 21) length must be less than or equal to 40.`);
        }

        if (parsedLine.providerZip && parsedLine.providerZip.length > 9) {
            job.messages.push(`Line ${lineNumber}: Provider Zip (Column 22) length must be less than or equal to 9.`);
        }

        if (parsedLine.renderingProviderId && parsedLine.renderingProviderId.length > 40) {
            job.messages.push(`Line ${lineNumber}: Rendering Provider ID (Column 23) length must be less than or equal to 40.`);
        }

        if (parsedLine.renderingProviderZip && parsedLine.renderingProviderZip.length > 9) {
            job.messages.push(`Line ${lineNumber}: Rendering Provider Zip (Column 24) length must be less than or equal to 9.`);
        }

        if (parsedLine.medicareId && parsedLine.medicareId.length > 40) {
            job.messages.push(`Line ${lineNumber}: Medicare ID (Column 25) length must be less than or equal to 40.`);
        }

        if (parsedLine.billType && parsedLine.billType.length > 3) {
            job.messages.push(`Line ${lineNumber}: Bill Type (Column 26) length must be less than or equal to 3.`);
        }

        if (parsedLine.admitSource && parsedLine.admitSource.length > 3) {
            job.messages.push(`Line ${lineNumber}: Admit Source (Column 27) length must be less than or equal to 3.`);
        }

        if (parsedLine.billed && isNaN(parsedLine.billed)) {
            job.messages.push(`Line ${lineNumber}: Billed (Column 28) must be a number. Exclude commas and dollar signs. Can include decimals.`);
        }

        if (parsedLine.allowed && isNaN(parsedLine.allowed)) {
            job.messages.push(`Line ${lineNumber}: Allowed (Column 29) must be a number. Exclude commas and dollar signs. Can include decimals.`);
        }

        if (parsedLine.units && isNaN(parsedLine.units)) {
            job.messages.push(`Line ${lineNumber}: Units (Column 30) must be a number. Exclude commas and dollar signs. Can include decimals.`);
        }

        if (parsedLine.dischargeStatus && parsedLine.dischargeStatus.length > 2) {
            job.messages.push(`Line ${lineNumber}: Discharge Status (Column 31) length must be less than or equal to 2.`);
        }

        let startingColumnCount = 31;
        // Validate all ICDDiag fields
        for (let i = 1; i <= 30; i++) {
            if (parsedLine[`icdDiag${i}`]) {
                if (parsedLine[`icdDiag${i}`].length > 7) {
                    job.messages.push(`Line ${lineNumber}: ICDDiag ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 7.`);
                } else if (parsedLine[`icdDiag${i}`].indexOf('.') !== -1) {
                    job.messages.push(`Line ${lineNumber}: ICDDiag ${i} (Column ${startingColumnCount+i}) must not contain a decimal point.`);
                }
            }
        }

        startingColumnCount = 61;
        // Validate all POA fields
        for (let i = 1; i <= 30; i++) {
            if (parsedLine[`poa${i}`] && parsedLine[`poa${i}`].length > 1) {
                job.messages.push(`Line ${lineNumber}: POA ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 1.`);
            }
        }

        startingColumnCount = 91;
        // Validate all ICDProc fields
        for (let i = 1; i <= 30; i++) {
            if (parsedLine[`icdProc${i}`]) {
                if (parsedLine[`icdProc${i}`].length > 7) {
                    job.messages.push(`Line ${lineNumber}: ICDProc ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 7.`);
                } else if (parsedLine[`icdProc${i}`].indexOf('.') !== -1) {
                    job.messages.push(`Line ${lineNumber}: ICDProc ${i} (Column ${startingColumnCount+i}) must not contain a decimal point.`);
                }
            }
        }

        startingColumnCount = 121;
        // Validate all ConditionCode fields
        for (let i = 1; i <= 11; i++) {
            if (parsedLine[`conditionCode${i}`] && parsedLine[`conditionCode${i}`].length > 2) {
                job.messages.push(`Line ${lineNumber}: Condition Code ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 2.`);
            }
        }

        startingColumnCount = 132;
        // Validate all OccurrenceCode fields
        for (let i = 1; i <= 4; i++) {
            if (parsedLine[`occurrenceCode${i}`] && parsedLine[`occurrenceCode${i}`].length > 2) {
                job.messages.push(`Line ${lineNumber}: Occurrence Code ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 2.`);
            }
        }

        startingColumnCount = 136;
        for (let i = 1; i <= 4; i++) {
            if (parsedLine[`occurrenceCodeDate${i}`] && !self.isValidDate(parsedLine[`occurrenceCodeDate${i}`])) {
                job.messages.push(`Line ${lineNumber}: Occurrence Code Date ${i} (Column ${startingColumnCount+i}) must be in the format (mm/dd/yyyy).`);
            }
        }        

        startingColumnCount = 140;
        // Validate all ValueCode fields
        for (let i = 1; i <= 12; i++) {
            if (parsedLine[`valueCode${i}`] && parsedLine[`valueCode${i}`].length > 2) {
                job.messages.push(`Line ${lineNumber}: Value Code ${i} (Column ${startingColumnCount+i}) length must be less than or equal to 2.`);
            }
        }

        startingColumnCount = 152;
        for (let i = 1; i <= 12; i++) {
            if (parsedLine[`valueCodeAmount${i}`] && isNaN(parsedLine[`valueCodeAmount${i}`])) {
                job.messages.push(`Line ${lineNumber}: Value Code Amount ${i} (Column ${startingColumnCount+i}) must be a number. Exclude commas and dollar signs. Can include decimals.`);
            }
        }

        if (parsedLine.siteNeutral && parsedLine.siteNeutral.length > 1) {
            job.messages.push(`Line ${lineNumber}: Site Neutral (Column 165) length must be less than or equal to 1.`);
        }

        if (parsedLine.dialysisOnsetDate && !self.isValidDate(parsedLine.dialysisOnsetDate)) {
            job.messages.push(`Line ${lineNumber}: Dialysis Onset (Column 166) Date must be in the format (mm/dd/yyyy).`);
        }

        if (parsedLine.pericarditis && parsedLine.pericarditis.length > 1) {
            job.messages.push(`Line ${lineNumber}: Pericarditis (Column 167) length must be less than or equal to 1.`);
        }

        if (parsedLine.giTractBleeding && parsedLine.giTractBleeding.length > 1) {
            job.messages.push(`Line ${lineNumber}: GI Tract Bleeding (Column 168) length must be less than or equal to 1.`);
        }

        if (parsedLine.hhsCAnemia && parsedLine.hhsCAnemia.length > 1) {
            job.messages.push(`Line ${lineNumber}: HHSC Anemia (Column 169) length must be less than or equal to 1.`);
        }

        if (parsedLine.myelodysplasticSyndrome && parsedLine.myelodysplasticSyndrome.length > 1) {
            job.messages.push(`Line ${lineNumber}: Myelodysplastic Syndrome (Column 170) length must be less than or equal to 1.`);
        }

        if (parsedLine.currentAllowed && isNaN(parsedLine.currentAllowed)) {
            job.messages.push(`Line ${lineNumber}: Current Allowed (Column 171) must be a number. Exclude commas and dollar signs. Can include decimals.`);
        }

        if (parsedLine.zip && parsedLine.zip.length > 9) {
            job.messages.push(`Line ${lineNumber}: Zip (Column 172) must be less than or equal to 9.`);
        }
    }

    self.isValidDate = (dateString) => {
        // Check if the date is in the format (mm/dd/yyyy)
        const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1[0-9]|2[0-9]|3[01])\/(18|19|20|21|22)\d\d$/;
        return regex.test(dateString);
    }

    self.onmessage = (args) => {
        const { type, request } = args.data;

        if (type === 'CANCELLATION') {
            self.stopProcessing = true;
        } else if (type === 'VALIDATION') {
            self.stopProcessing = false;
            setTimeout(() => self.processValidation(request), 0);
        }
    };
};

let code = BatchFileValidationWorker.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const workerScriptUrl = URL.createObjectURL(blob);

module.exports = workerScriptUrl;